import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import GetMyLocationUseCase from './GetMyLocationUseCase';

export const initializeGeoLocationUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetMyLocationUseCase, {
        useClass: GetMyLocationUseCase,
    });
};
